
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-access-request",
      function () {
        return require("private-next-pages/data-access-request/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-access-request"])
      });
    }
  